import { reactive } from 'vue'
import { io } from 'socket.io-client'
import vuexState from './store/index.js'
import config from '@/config'
export const state = reactive({
  connected: false,
  location_update: null,
  location_update_third_party: null,
  update_trip_status: null,
  reported_issue_update: null,
  dismiss_report_issue_update: null,
  operator_support_chat_update: null,
  operator_branch_request_update: null,
  time_off_request_update: null,
  reservation_request_update: null,
  trip_exceed_distance: null,
  driver_allowance_request_update: null,
  auto_assign_trip: null,
  assign_vehicle_route: null,
  generateTripSuccess: null,
  generateTripFailed: null,
  escalationNotification: null,
})
const VUE_APP_SOCKET_URL = config.socketUrl
// const socketDomain = VUE_APP_API_URL.replace('/backend', '');

export const socket = io(VUE_APP_SOCKET_URL, {
  autoConnect: false,
  timeout: 5000,
  transports: ['websocket'],
  // path: '/backend/socket.io',
})

socket.on('connect', () => {
  console.log('Socket connected 🚀')
  state.connected = true
})

socket.on('disconnect', () => {
  console.log('Socket disconnected')

  state.connected = false
  state.location_update = null
  state.location_update_third_party = null
  state.update_trip_status = null
  state.reported_issue_update = null
  state.dismiss_report_issue_update = null
  state.operator_support_chat_update = null
  state.operator_branch_request_update = null
  state.time_off_request_update = null
  state.reservation_request_update = null
  state.trip_exceed_distance = null
  state.driver_allowance_request_update = null
  state.auto_assign_trip = null
  state.assign_vehicle_route = null
  state.generateTripSuccess = null
  state.generateTripFailed = null
  state.escalationNotification = null
})

socket.on('connect_error', (reason) => {
  console.log('Socket getting error ❌ : ' + reason.message)
})

socket.on('location-update', (data) => {
  console.log('Notification from location-update channel')
  state.location_update = data
})
socket.on('location-update-third-party', (data) => {
  console.log('Notification from location-update-third-party channel')
  state.location_update_third_party = data
})

socket.on('update-trip-status', (data) => {
  console.log('Notification from update-trip-status channel')
  state.update_trip_status = data
})

socket.on('reportMessage', (data) => {
  console.log('Notification from report message channel', data?.report?._id)
  state.reported_issue_update = data
})

socket.on('dismiss-report', (data) => {
  console.info('Notification from dismiss-report channel', data?.report?._id)
  state.dismiss_report_issue_update = data
})

socket.on('operator-support-chat', (data) => {
  console.info('Notification from operator-support-chat channel', data?.driver?._id)
  state.operator_support_chat_update = data
})

socket.on(`auto-assign-trips-job-completed`, (data) => {
  state.auto_assign_trip = data
})


export function subscribeToTripLiveLocation(tripId, handler) {
  const eventName = `trip-${tripId}-live-location`
  socket.on(eventName, handler)
  return eventName
}

export function unsubscribeFromTripLiveLocation(eventName, handler) {
  if (eventName) socket.off(eventName, handler)
}

const resourceRequestInterval = setInterval(resourceRequest, 1000)

function resourceRequest() {
  if (vuexState.getters['enums/user_info_loaded']) {
    if (!vuexState.getters['enums/is_not_permitted']('viewTemporaryResourcesRequest')) {
      socket.on('operator-branch-request', (data) => {
        if (data.users.includes(vuexState.getters['enums/user_info']?.userID)) {
          console.info('Notification from operator-branch-request channel', data?.request?._id)
          state.operator_branch_request_update = data?.request
        }
      })
    }
    clearInterval(resourceRequestInterval)
  }
}

const timeOffRequestInterval = setInterval(timeOffRequest, 1000)

function timeOffRequest() {
  if (vuexState.getters['enums/user_info_loaded']) {
    socket.on(`time-off-request-${vuexState.getters['enums/user_info'].userID}`, (data) => {
      state.time_off_request_update = data
    })
    clearInterval(timeOffRequestInterval)
  }
}

const reservationRequestInterval = setInterval(reservationRequest, 1000)

function reservationRequest() {
  if (vuexState.getters['enums/user_info_loaded']) {
    socket.on(`reservation-request-${vuexState.getters['enums/user_info'].userID}`, (data) => {
      state.reservation_request_update = data
    })
    clearInterval(reservationRequestInterval)
  }
}

const tripExceedDistanceInterval = setInterval(tripExceedDistance, 1000)

function tripExceedDistance() {
  if (vuexState.getters['enums/user_info_loaded']) {
    socket.on(`trip-exceed-distance-${vuexState.getters['enums/user_info'].userID}`, (data) => {
      console.info('Notification from trip-exceed-distance channel')
      state.trip_exceed_distance = data
    })
    clearInterval(tripExceedDistanceInterval)
  }
}

const allowanceRequestInterval = setInterval(allowanceRequest, 1000)

function allowanceRequest() {
  if (vuexState.getters['enums/user_info_loaded']) {
    socket.on(`driver-allowance-request-${vuexState.getters['enums/user_info'].userID}`, (data) => {
      state.driver_allowance_request_update = data
    })
    clearInterval(allowanceRequestInterval)
  }
}
const changePasswordInterval = setInterval(changePassword, 1000)

function changePassword() {
  if (vuexState.getters['enums/user_info_loaded']) {
    socket.on(`change-password-${vuexState.getters['enums/user_info'].userID}`, (data) => {
      vuexState.dispatch('enums/GET_CHANGE_PASSWORD_TOKEN', data?.token)
    })
    clearInterval(changePasswordInterval)
  }
}

const assignVehicleToRouteInterval = setInterval(assignVehicleToRouteRequest, 1000)

function assignVehicleToRouteRequest() {
  if (vuexState.getters['enums/user_info'].userID) {
    socket.on(`vehicle-assignment-${vuexState.getters['enums/user_info'].userID}`, (data) => {
      state.assign_vehicle_route = data
    })
    clearInterval(assignVehicleToRouteInterval)
  }
}

const generationTripContractSuccessInterval = setInterval(
  generationTripContractSuccessRequest,
  1000
)

function generationTripContractSuccessRequest() {
  if (vuexState.getters['enums/user_info'].userID) {
    socket.on(`trip-generation-complete-${vuexState.getters['enums/user_info'].userID}`, (data) => {
      state.generateTripSuccess = data
    })
    clearInterval(generationTripContractSuccessInterval)
  }
}

const generationTripContractFailedInterval = setInterval(generationTripContractFailedRequest, 1000)

function generationTripContractFailedRequest() {
  if (vuexState.getters['enums/user_info'].userID) {
    socket.on(`trip-generation-failed-${vuexState.getters['enums/user_info'].userID}`, (data) => {
      state.generateTripFailed = data
    })
    clearInterval(generationTripContractFailedInterval)
  }
}
const escalationNotificationInterval = setInterval(escalationNotification, 1000)

function escalationNotification() {
  if (vuexState.getters['enums/user_info'].userID) {
    socket.on(`escalation-notification-${vuexState.getters['enums/user_info'].userID}`, (data) => {
      state.escalationNotification = data
    })
    clearInterval(escalationNotificationInterval)
  }
}
